<template>
  <modal title="Success" subtitle="Subscribed" @close="$emit('close')" :show-close-button="true" class="modal__success">
    <h3 class="modal-success__heading">Subscription successful!</h3>
    <p class="modal-success__text modal-success__text--smaller">Your subscription will automatically renew on the:</p>
    <p class="modal__text modal__text--bold modal__text--bigger modal__text--center">{{ nextPaymentDate }}</p>
    <div class="modal__text-footer">
      <p class="modal__text modal__text--small modal__text--center">Go to <a class="modal__link" href="https://app.fonetti.com" target="_blank">app.fonetti.com</a> or download Fonetti from your tablet's App Store to start reading.</p>
      <p class="modal__text modal__text--small modal__text--center modal__text" v-if="isDowngrading">Your current subscription will continue until your renewal date, at which point you will be downgraded.</p>
    </div>
    <button class="modal__button btn btn-primary btn-block" @click="cb" v-if="$store.state.user.readers.length === 0">Download</button>
    <template v-slot:footer>
      <button class="btn btn-cancel modal__button" @click="$emit('close')">Close</button>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/utils/Modal';

export default {
  name: 'subscription-success-modal',
  components: {
    Modal,
  },
  props: {
    nextPaymentDate: {
      required: true,
      type: String,
    },
    isDowngrading: {
      required: false,
      type: Boolean,
      default: false,
    },
    cb: {
      required: true,
      type: Function,
    },
  },
};
</script>
